import pluralize from 'pluralize';

export function getEntityCollectionName(entityName) {
  return pluralize(entityName);
}
